import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name: 'address',
    initialState: {
        data: {},
    },
    reducers: {
        refreshData: (state) => {
            state.data = null
        },
        setUserData: (state, {payload : data}) => {
            state.data = data
        },
        getUserData: (state, action) => {
            state.data = action.payload
        },
    },
});

export const { refreshData, setUserData, getUserData } = userSlice.actions;

export default userSlice.reducer;